import React, { useState, useContext } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, HelpCircle } from 'lucide-react';
import { AppContext } from '../AppContext';
import './FaqPage.css';

const FaqPage = () => {
  const { faqEntries, lang } = useContext(AppContext);
  const [openIdx, setOpenIdx] = useState(0);
  const isMr = lang === 'mr';

  return (
    <div className="faq-page">
      <section className="faq-hero">
        <div className="faq-hero-bg">
          <img src="images/banner g.png" alt="GDR FAQ Banner" />
          <div className="faq-hero-overlay"></div>
        </div>
        <motion.div
          className="faq-hero-content"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <span className="faq-eyebrow">✦ FREQUENTLY ASKED QUESTIONS ✦</span>
          <h1>Everything You Need To Know</h1>
          <p>Answers about our hallmarked jewellery, ring sizing, custom orders, and showroom policies.</p>
        </motion.div>
      </section>

      <div className="faq-container">
        <div className="faq-list">
          {faqEntries.map((faq, i) => (
            <div key={faq.id || i} className={`faq-accordion-item ${openIdx === i ? 'open' : ''}`}>
               <button className="faq-question-btn" onClick={() => setOpenIdx(openIdx === i ? null : i)}>
                 <span><HelpCircle size={18} color="#d4af37" /> {isMr ? (faq.questionMr || faq.question) : faq.question}</span>
                 <ChevronDown size={18} className="faq-arrow" />
               </button>
               <AnimatePresence>
                 {openIdx === i && (
                   <motion.div
                     className="faq-answer-content"
                     initial={{ opacity: 0, height: 0 }}
                     animate={{ opacity: 1, height: 'auto' }}
                     exit={{ opacity: 0, height: 0 }}
                   >
                     <p>{isMr ? (faq.answerMr || faq.answer) : faq.answer}</p>
                   </motion.div>
                 )}
               </AnimatePresence>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FaqPage;
